import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import { usePage } from '@inertiajs/vue3';
import usePermissions from '@/composables/usePermissions';
import { computed } from 'vue';

import { ShieldCheck } from "lucide-vue-next"
import CodeIcon from '@/components/Navigation/components/v2/icons/CodeIcon.vue';
import UserIcon from '@/components/Navigation/components/v2/icons/UserIcon.vue';
import SettingsIcon from '@/components/Navigation/components/v2/icons/SettingsIcon.vue';
import PurchaseIcon from '@/components/Navigation/components/v2/icons/PurchaseIcon.vue';
import { ILink } from '@/types/Atomic/ISidebarData';

export default () => {
    const { isOwner, isEditorAndUp } = usePermissions();
    const globalProps = computed(() => usePage<ITopolPageProps>().props);
    const isPersonalTeam = computed(
        () => globalProps.value.team?.personal_team ?? false
    );
    const { subscriptionRouteName } = useSubscriptionLabel();
    const { membersCount } = useTeamsAndMembers();

    const linksPlugin = computed((): ILink[] => {
        // Plugin (api-tokens) is personal-team-scoped — hide it on non-personal teams.
        const links: ILink[] = [];

        if (isPersonalTeam.value) {
            links.push({
                name: 'API Tokens',
                href: route('plugin.api-tokens.index'),
                icon: CodeIcon,
                count: undefined,
                id: '/plugin',
            });
        }

        links.push({
            name: 'Members',
            href: route('members.index'),
            icon: UserIcon,
            count: membersCount.value,
            reserveBadge: true,
            id: '/members',
        });

        if (isEditorAndUp.value) {
            links.push({
                name: 'Settings',
                href: route('settings.profile-settings.index'),
                icon: SettingsIcon,
                count: undefined,
                id: '/settings',
            });
        }

        if (isOwner.value) {
            links.push({
                name: 'Billing',
                href: route(subscriptionRouteName.value),
                icon: PurchaseIcon,
                count: undefined,
                id: '/billing/',
            });
        }

        if (globalProps.value.isAdmin) {
            links.push({
                name: 'Kiosk',
                href: route('kiosk.dashboard.index'),
                icon: ShieldCheck,
                count: undefined,
                id: '/kiosk',
            });
        }

        return links;
    });

    return {
        links: linksPlugin,
    };
};
